import BaseService from "@/app/core/base/BaseService";
import { toast } from "react-toastify";
import { HandleErrors } from "../../util/helpers/ErrorHelper";

export const PaymentController = {
    BaseModel: { 
        deliveryId: "",
        paymentMethod: "credit_card",
        cardId: {
            cardId: "",
            cardCvv: ""
        }
    },

    Payment: async function (data, response, error){
        await BaseService(
            {
              method: "POST",
              url: `payment/`,
              data: data,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
        );
    },

    Get: async function (id, response, error){
        await BaseService(
            {
              method: "GET",
              url: `payment/${id}`,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
        );
    },

    Events: async function (response, error){
        await BaseService(
            {
              method: "POST",
              url: `payment/events/`,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
        );
    },
    
}